import type { FaireProductEntity } from "../../entity_types/product";

export const p_war5zdbqkd: FaireProductEntity = {
  token: "p_war5zdbqkd",
  type: "product",
  name: "LM-BG-1003 TOTE BAG LT PINK/BUBBLEGUM STRIPE",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/88565f36c0b8b9b77f4107bb3aaded95732d9ac7531d09a711f57bf8b934f01d.png",
  galleryImageUrls: [],
  priceDollars: 15,
  description: "Tote Bag LT PINK/BUBBLEGUM STRIPE from Girlie Girl Originals features a striped light pink/bubblegum design and is styled for women. The bag has handles and an open top for access to items, suitable for everyday use and casual wear. Girlie Girl Originals offers fashion-forward designs with a southern flair; please contact us for our MAP policy.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:10.668Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
